const doc = [({"en":({"postEmailChatUnit":"Registered email user"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;